// extracted by mini-css-extract-plugin
export default {"container":"Container_container__VVOCq","flex":"Container_flex__yTgVA"};